import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {host} from '../../function/api'

const initialState = {
    itemList:[],
    loading: false,
    success: false,
    status: false,
    message: '',
    errorTitle: ''
}

export const DocumentManagmentStore = createAsyncThunk(
    'document/managment/store',
    async(data, thunckAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}DocumentPermission`,
                data: data,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'Access-Control-Allow-Origin': "*",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data

        } catch(error) {
            return thunckAPI.rejectWithValue(error)
        }
    }
);
export const fetchDocumentUser = createAsyncThunk(
    'fetch/DocumentUserPermission',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}DocumentPermission/user`,
                data: data,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
const DocumentManagmentSlice = createSlice({
    name: 'DocumentManagment',
    initialState,
    reducers: {

    },
    extraReducers: {
        [DocumentManagmentStore.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.status = true
            state.message = payload.message
        },
        [DocumentManagmentStore.pending] : (state) => {
            state.loading = true    
            state.success = false
            state.status = false
        },
        [DocumentManagmentStore.rejected]: (state, {payload}) => {
            state.loading = false
            state.success = false
            state.status = false
            // if(payload.response.data.error) {
            //     state.errorTitle = payload.response.data.error.title
            //     state.errorstatuss = payload.response.data.error.store_id
            // }else if(payload.response.data.message) {
            //     state.message = payload.response.data.message
            // }
            
        },
        [fetchDocumentUser.fulfilled]: (state, action) => {
            state.loading = false
            state.success = true
            state.status = action.payload.status
            state.itemList = action.payload.data
        },
        [fetchDocumentUser.pending]: (state) => {
            state.loading = true
            state.success = false
            state.status = false
            state.itemList = []
        },
        [fetchDocumentUser.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            state.status = false
            if(payload.response.data.error){
                state.errorProfile = payload.response.data.errorProfile
                state.errorPermission = payload.response.data.permission
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
});

export const {} = DocumentManagmentSlice.actions;
export default DocumentManagmentSlice.reducer;